

















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getComments, addComment } from '@/api/api'
import moment from 'moment'

@Component({
  components: {}
})
export default class Topic extends Vue {
  @Prop() topicInfo!: any
  showComments: boolean = true // 是否显示评论
  topicContent: any = '' // 看点内容
  commentList: Array<object> = [] // 评论列表
  pageSize: number = 10 // 分页组件page-size
  commentTotal: number = 0 // 评论数量
  comment: string = '' // 评论

  mounted() {
    this._getComments(1)
  }

  /**
   * 展开隐藏评论
   */
  toggle(): void {
    this.showComments = !this.showComments
  }

  /**
   * 换页
   */
  async changePage(page: number): Promise<any> {
    this._loading()
    await this._getComments(page)
    this._loading().close()
  }

  /**
   * 返回看点页
   */
  back(): void {
    this.$emit('onBack', '0')
  }

  /**
   * 发布评论
   */
  publish(): void {
    this._addComment()
  }

  /**
   *
   */
  dateFormat(timestamp: any): any {
    // return moment(timestamp).format('YYYY-MM-DD hh:mm:ss')
    moment.locale('zh-cn')
    return moment(timestamp).fromNow()
  }

  /**
   * 查看话题信息
   */
  async _getComments(page: number, size: number = this.pageSize): Promise<any> {
    getComments({
      topic_id: this.topicInfo.topic_id,
      page,
      size
    }).then((res: any) => {
      if (res.data.code === 101) {
        this.commentList = res.data.result.records
        this.commentTotal = res.data.result.total
      }
    })
  }

  /**
   * 发布评论
   */
  _addComment(): void {
    addComment({
      topic_id: this.topicInfo.topic_id,
      comment_context: this.comment
    }).then((res: any) => {
      console.log(res)
      if (res.data.code === 101) {
        this.$message.success('发布成功')
        this.comment = ''
        this._getComments(1)
      }
    })
  }

  /**
   * 显示loading
   */
  _loading(): any {
    const vm = this
    this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    return {
      close() {
        vm.$loading({}).close()
      }
    }
  }
}
